import { Routes, Route, Navigate } from "react-router-dom"; // @ts-ignore - react-router-dom is not a valid module
import { KarunaProviders } from "./KarunaProviders";
import NotFound from "@/project/karuna/pages/NotFound";
import SchoolDashboard from "@/project/karuna/pages/school/SchoolDashboard";
import SchoolAuth from "@/project/karuna/pages/school/SchoolAuth";
import SchoolLogin from "@/project/karuna/pages/school/SchoolLogin";
import SchoolActivities from "@/project/karuna/pages/school/SchoolActivities";
import SchoolActivityDetail from "@/project/karuna/pages/school/SchoolActivityDetail";
import SchoolSubmissions from "@/project/karuna/pages/school/SchoolSubmissions";
import SchoolSubmissionDetail from "@/project/karuna/pages/school/SchoolSubmissionDetail";
import SchoolEventSubmission from "@/project/karuna/pages/school/SchoolEventSubmission";
import SchoolStudents from "@/project/karuna/pages/school/SchoolStudents";
import SchoolProfile from "@/project/karuna/pages/school/SchoolProfile";
import SchoolOnboarding from "@/project/karuna/pages/school/SchoolOnboarding";
import AdminDashboard from "@/project/karuna/pages/admin/AdminDashboard";
import AdminSchools from "@/project/karuna/pages/admin/AdminSchools";
import AdminSubmissions from "@/project/karuna/pages/admin/AdminSubmissions";
import AdminSubmissionReview from "@/project/karuna/pages/admin/AdminSubmissionReview";
import AdminSubmissionReports from "@/project/karuna/pages/admin/AdminSubmissionReports";
import AdminActivity from "@/project/karuna/pages/admin/AdminActivity";
import AdminActivityView from "@/project/karuna/pages/admin/AdminActivityView";
import AdminStudents from "@/project/karuna/pages/admin/AdminStudents";
import AdminDonations from "@/project/karuna/pages/admin/AdminDonations";
import AdminSchoolRankings from "@/project/karuna/pages/admin/AdminSchoolRankings";
import AdminCertificates from "@/project/karuna/pages/admin/AdminCertificates";
import AdminSettings from "@/project/karuna/pages/admin/AdminSettings";
import AdminSchoolApproval from "@/project/karuna/pages/admin/AdminSchoolApproval";
import AdminContactUs from "@/project/karuna/pages/admin/AdminContactUs";
import AdminLogin from "@/project/karuna/pages/admin/AdminLogin";
import AdminUsers from "@/project/karuna/pages/admin/AdminUsers";
import { AdminPortalShell } from "@/project/karuna/pages/admin/AdminPortalShell";
import {
  adminRoute,
  ADMIN_PERMISSIONS,
} from "@/project/karuna/pages/admin/adminRoutes";
import EvaluatorDashboard from "@/project/karuna/pages/evaluator/EvaluatorDashboard";
import EvaluatorSubmissions from "@/project/karuna/pages/evaluator/EvaluatorSubmissions";

/** Paths under /admin/* */
export function KarunaAdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route element={<AdminPortalShell />}>
        <Route
          path="dashboard"
          element={adminRoute(ADMIN_PERMISSIONS.DASHBOARD, <AdminDashboard />)}
        />
        <Route
          path="schools"
          element={adminRoute(ADMIN_PERMISSIONS.SCHOOLS, <AdminSchools />)}
        />
        <Route
          path="school-approval"
          element={adminRoute(
            ADMIN_PERMISSIONS.SCHOOLS,
            <AdminSchoolApproval />
          )}
        />
        <Route
          path="submissions"
          element={adminRoute(
            ADMIN_PERMISSIONS.SUBMISSIONS,
            <AdminSubmissions />
          )}
        />
        <Route
          path="submissions/:id"
          element={adminRoute(
            ADMIN_PERMISSIONS.SUBMISSIONS,
            <AdminSubmissionReview />
          )}
        />
        <Route
          path="submission-reports"
          element={adminRoute(
            ADMIN_PERMISSIONS.SUBMISSION_REPORTS,
            <AdminSubmissionReports />
          )}
        />
        <Route
          path="activity"
          element={adminRoute(ADMIN_PERMISSIONS.ACTIVITY, <AdminActivity />)}
        />
        <Route
          path="activity/add"
          element={<Navigate to=".." relative="path" replace />}
        />
        <Route
          path="activity/:id"
          element={adminRoute(
            ADMIN_PERMISSIONS.ACTIVITY,
            <AdminActivityView />
          )}
        />
        <Route
          path="activity/:id/edit"
          element={<Navigate to=".." relative="path" replace />}
        />
        <Route
          path="students"
          element={adminRoute(ADMIN_PERMISSIONS.STUDENTS, <AdminStudents />)}
        />
        <Route
          path="donations"
          element={adminRoute(ADMIN_PERMISSIONS.DONATIONS, <AdminDonations />)}
        />
        <Route
          path="school-rankings"
          element={adminRoute(
            ADMIN_PERMISSIONS.SCHOOL_RANKINGS,
            <AdminSchoolRankings />
          )}
        />
        <Route
          path="certificates"
          element={adminRoute(
            ADMIN_PERMISSIONS.CERTIFICATES,
            <AdminCertificates />
          )}
        />
        <Route
          path="settings"
          element={adminRoute(ADMIN_PERMISSIONS.SETTINGS, <AdminSettings />)}
        />
        <Route
          path="contact-us"
          element={adminRoute(ADMIN_PERMISSIONS.CONTACT_US, <AdminContactUs />)}
        />
        <Route
          path="users"
          element={adminRoute(ADMIN_PERMISSIONS.USERS, <AdminUsers />)}
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

/** Paths under /school/* */
export function KarunaSchoolRoutes() {
  return (
    <Routes>
      <Route path="auth" element={<SchoolAuth />} />
      <Route path="login" element={<SchoolLogin />} />
      <Route path="dashboard" element={<SchoolDashboard />} />
      <Route path="activities" element={<SchoolActivities />} />
      <Route path="activities/:id" element={<SchoolActivityDetail />} />
      <Route path="submissions" element={<SchoolSubmissions />} />
      <Route path="submissions/:id" element={<SchoolSubmissionDetail />} />
      <Route path="submit/:id" element={<SchoolEventSubmission />} />
      <Route path="students" element={<SchoolStudents />} />
      <Route path="profile" element={<SchoolProfile />} />
      <Route path="onboarding" element={<SchoolOnboarding />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/** Paths under /evaluator/* */
export function KarunaEvaluatorRoutes() {
  return (
    <Routes>
      <Route path="dashboard" element={<EvaluatorDashboard />} />
      <Route path="submissions" element={<EvaluatorSubmissions />} />
      <Route path="leaderboard" element={<NotFound />} />
      <Route path="schools" element={<NotFound />} />
      <Route path="students" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/** The main Karuna Application wrapper */
export default function KarunaApp() {
  return (
    <Routes>
      <Route element={<KarunaProviders />}>
        <Route path="admin/*" element={<KarunaAdminRoutes />} />
        <Route path="school/*" element={<KarunaSchoolRoutes />} />
        <Route path="evaluator/*" element={<KarunaEvaluatorRoutes />} />
      </Route>
    </Routes>
  );
}
